import equal from 'lodash.isequal';
import { sendToConfessor } from './debug';
/**
 * Check equality (deep)
 */
export const isEqual = (obj1, obj2) => equal(obj1, obj2);
/**
 * No own properties? -> return null
 */
export const getNullableObject = (object, nullable = false) => nullable && isObject(object) && !Object.keys(object).length ? null : object;
/**
 * Is value Object?
 */
export const isObject = (item) => !!(item && typeof item === 'object' && !Array.isArray(item));
/**
 * Is value valid SHA256 string?
 */
export const isValidSHA256String = (value) => typeof value === 'string' && /^[a-f0-9]{64}$/gi.test(value);
/**
 * IS value valid UUID (any version, just simple char types + length check) string
 */
export const isValidUUID = (value) => typeof value === 'string' && /^[0-9a-f-]{36}$/gi.test(value);
/**
 * Cast Boolean from other types
 */
export const castBoolean = (value) => {
    if ([0, 'false', false].includes(value)) {
        return false;
    }
    if ([1, 'true', true].includes(value)) {
        return true;
    }
    return null;
};
/**
 * Browser detection helpers
 */
export const browser = {
    isSafari: () => navigator.userAgent.includes('Safari/') &&
        !navigator.userAgent.includes('Chrome/') &&
        !navigator.userAgent.includes('Chromium/'),
    isFirefox: () => navigator.userAgent.includes('Firefox/') && !navigator.userAgent.includes('Seamonkey/'),
};
/**
 * Load external script (apend to DOM a handle as promise).
 */
export const loadScript = (url, id) => {
    const identifier = `identity-storage-ext-script:${id}`;
    const markLoaded = 'loaded';
    const element = document.getElementById(identifier);
    // external script tag already created
    if (element) {
        return element.classList.contains(markLoaded) ? Promise.resolve() : Promise.reject();
    }
    // create external script tag (+ handle load states)
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const _reportAndReject = () => {
            sendToConfessor(`ScriptLoadError (${url})`);
            reject();
        };
        const _markAndResolve = () => {
            script.classList.add(markLoaded);
            resolve();
        };
        script.src = url;
        script.id = identifier;
        script.onload = _markAndResolve;
        script.onerror = _reportAndReject;
        script.onabort = _reportAndReject;
        (document.body || document.head || document.documentElement).appendChild(script);
    });
};
// get HOSTNAME
export const getHostname = () => { var _a, _b; return (_b = (_a = window.location) === null || _a === void 0 ? void 0 : _a.hostname) === null || _b === void 0 ? void 0 : _b.replace(/^www\./, ''); };
// typeguard for IDENTITIES_SIMPLIFIED
export const isIdentitiesSimplifiedObject = (identities) => {
    if (!isObject(identities)) {
        return false;
    }
    const requiredKeys = ['value', 'created', 'updated', 'state', 'settled'];
    const isIdentityObject = Object.values(identities || {}).every((value) => {
        return isObject(value) && requiredKeys.every((key) => key in value);
    });
    return !isIdentityObject;
};
